import axios from "axios";
import {
  STATES_ATTEMPT,
  STATES_SUCCESS,
  STATES_FAILED,
  /////////////////
} from "../types/stateTypes";
import { config } from "../../config";
const url_api = config.api.godiway;
export function loading() {
  return {
    type: STATES_ATTEMPT
  };
}

export function success(data) {
  return {
    type: STATES_SUCCESS,
    data: data
  };
}

export function failed(error) {
  return {
    type: STATES_FAILED,
    error: error
  };
}
/////////////////////////
export const loadList = (data: Object) => async dispatch => {

  dispatch(loading());
  await axios
    .get(url_api + "state", {
      params: {
        id: data.user_id,
      },
      headers: { Authorization: `Bearer ${data.token}` },
    })
    .then(function (response) {
      if (response.status < 300) {
        if (response.data.status === "Success")
          dispatch(success(response.data.body));
        else dispatch(failed(response.data.body));
      } else {
        dispatch(failed("try_later"));
      }
    })
    .catch(function (error) {
      if (error.Error) {
        dispatch(failed("try_later"));
      } else {
        dispatch(failed("try_later"));
      }
      return;
    });
};
